import { Link } from 'react-router-dom';
import { HomeIcon, LockClosedIcon } from '@heroicons/react/24/outline';

const Unauthorized = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* Logo */}
          <img
            className="mx-auto h-24 w-auto mb-8"
            src="/assets/icons/nazai-studio-logo.png"
            alt="Nazaï Studio"
          />
          
          {/* 403 Error */}
          <div className="mb-8">
            <div className="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-6">
              <LockClosedIcon className="h-12 w-12 text-red-600" />
            </div>
            <h1 className="text-6xl font-bold text-red-600">403</h1>
            <h2 className="text-3xl font-bold text-gray-900 mt-4">Accès non autorisé</h2>
            <p className="text-lg text-gray-600 mt-4">
              Vous n'avez pas les permissions nécessaires pour accéder à cette page.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
            >
              <HomeIcon className="h-5 w-5 mr-2" />
              Retour à l'accueil
            </Link>
            
            <div className="block">
              <Link
                to="/login"
                className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
              >
                Se connecter
              </Link>
            </div>
          </div>

          {/* Help Info */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-4">
              Besoin d'aide ?
            </p>
            <a
              href="mailto:hello@nazaistudio.ma"
              className="text-sm text-red-600 hover:text-red-700 font-medium"
            >
              Contactez notre support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
